<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row class="mx-auto" v-if="numbers">
        <v-col class="pa-0 py-1 text-left">
          <span class="font-weight-bold caption" :style="`color: ${background}`">{{
            currentTime
          }}</span>
        </v-col>
        <v-col class="text-right px-0 py-1">
          <span class="font-weight-bold caption" :style="`color: ${background}`">{{
            duration ? "-" + formatTime(duration - value) : "00:00"
          }}</span>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <div
        ref="full"
        class="full hover"
        :style="`background-color: ${background}; height: ${height}px;`"
        @mouseover="onHover"
        @mouseleave="onLeave"
        @click="onClick"
        @mousemove="onMouseMove"
      >
        <div
          class="fill"
          :style="`width: ${width}%; background: ${fillColor}; height: ${height}px;`"
        ></div>
        <div
          v-if="hover"
          class="little-ball"
          ref="ball"
          :style="`margin-left: ${offset}px`"
          @click.stop="onChange"
          @mousemove.stop
          @mouseleave.stop
          @mouseover.stop
        ></div>
        <v-fade-transition>
          <v-card
            v-if="hover && numbers && !noCard && timeStamp"
            class="absolute py-2 px-2 timebox"
            :style="`margin-left: ${offset - 87}px;   margin-top: ${video ? -80 : -90}px;`"
            @click.stop
            @mousemove.stop
            @mouseleave.stop
            @mouseover.stop
          >
            {{ timeStamp }}
            <div class="triangle"></div>
          </v-card>
        </v-fade-transition>
      </div>
    </v-col>
  </v-row>
</template>
<script>
/* eslint-disable no-console */
export default {
  props: {
    value: {
      required: true,
      type: Number,
    },
    duration: {
      required: true,
      type: Number,
    },
    background: {
      required: false,
      type: String,
      default: "#8A8F9C",
    },
    fillColor: {
      required: false,
      type: String,
      default:
        "transparent linear-gradient(180deg, #FF2E7B 0%, #C71252 100%) 0% 0% no-repeat padding-box;",
    },
    video: {
      default: false,
      type: Boolean,
      required: false,
    },
    numbers: {
      default: true,
      type: Boolean,
      required: false,
    },
    readonly: {
      default: false,
      type: Boolean,
      required: false,
    },
    height: {
      type: String,
      required: false,
      default: "7",
    },
    noCard: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      hover: false,
      offset: 0,
      timeStamp: 0,
    };
  },
  computed: {
    currentTime() {
      if (this.value) return this.formatTime(this.value);
      else return "00:00";
    },
    width() {
      let value = (this.value * 100) / this.duration;
      if (!value) value = 0;
      return value;
    },
  },
  methods: {
    onHover(e) {
      this.hover = true;
      if (e.offsetX > 0) {
        this.offset = e.offsetX - 2;
      }
    },
    onLeave() {
      this.hover = false;
    },
    onClick(e) {
      if (e.offsetX > 0) {
        this.emit(e.offsetX - 2);
      }
    },
    onChange() {
      this.emit(this.offset);
    },
    onMouseMove(e) {
      if (this.hover && e.offsetX > 0) this.offset = e.offsetX - 2;
      const fullWidth = this.getFullWidth();
      const time = (this.offset * this.duration) / fullWidth;
      if (time) this.timeStamp = this.formatTime(time);
    },
    emit(value) {
      const fullWidth = this.getFullWidth();
      this.$emit("input", (value * this.duration) / fullWidth);
    },
    addZero(value) {
      if (value < 10) return "0" + String(Number.parseInt(value));
      else return String(Number.parseInt(value));
    },
    formatTime(value) {
      let minutes = Number.parseInt(value) / 60;
      let seconds = Number.parseInt(value) % 60;
      return this.addZero(minutes) + ":" + this.addZero(seconds);
    },
    getFullWidth() {
      return this.$refs.full.getBoundingClientRect().width;
    },
  },
};
</script>
<style scoped>
.full {
  background-color: #8a8b9b;
  border-radius: 10px !important;
}
.fill {
  transition: all 0.2s ease-out;
  border-radius: 10px !important;
}
.little-ball {
  width: 7px;
  margin-top: -7px;
  border-radius: 50%;
  /* border: 1px solid black; */
}
.timebox {
  font-size: 36px;
  border-radius: 8px !important;
  background: #2a2a2a !important;
  color: white !important;
}
.triangle {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 10px solid #2a2a2a;
  position: absolute;
  left: 80%;
  bottom: -7px;
}
</style>
